<template>
    <access-denied v-if="accessDenied" title="cliente" />
    <div style="height: 100%" v-else>
        <div id="main" v-show="!rotaAninhada">
            <div class="page">
                <!-- Título -->
                <div class="clientes vertical-flow">
                    <div class="listing-header">
                        <div class="title-breadcrumb">
                            <h1 class="title">
                                {{ $t('clientes') }}
                                <a class="pl-1" v-if="hide.hideInfo" @click="infoIsHidden()">
                                    <b-icon
                                        v-if="!hide.infoIsHidden"
                                        icon="eye-off-outline"
                                        type="is-danger"
                                    />
                                    <b-icon
                                        v-if="hide.infoIsHidden"
                                        icon="eye-outline"
                                        type="is-success"
                                    />
                                </a>
                            </h1>
                            <nav class="breadcrumb" aria-label="breadcrumbs">
                                <ul>
                                    <li>
                                        <a class="a-inativo">{{ $t('promotor') }}</a>
                                    </li>
                                    <li>
                                        <a class="a-inativo">{{ $t('cadastros') }}</a>
                                    </li>
                                    <li>
                                        <a aria-current="page">{{ $t('clientes') }}</a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                        <div class="header-buttons">
                            <button
                                v-if="permissao.create"
                                class="delete-btn"
                                type="button"
                                tag="button"
                                @click="$router.push({ name: 'clientes-importacao' })"
                            >
                                {{ $t('importar') }}
                            </button>
                            <button
                                v-if="permissao.create"
                                class="save-btn"
                                type="button"
                                tag="button"
                                @click="$router.push({ name: 'clientes-new' })"
                            >
                                {{ $t('adicionar') }}
                            </button>
                        </div>
                    </div>

                    <!-- PESQUISA E FILTROS -->
                    <div class="dynamic-filter-bar mb-3">
                        <div class="dynamic-filter-bar-form form-columns-fit">
                            <search-bar :onSearch="debouncedOnSearch" tooltipLabel="msg-busca-pro-cliente" />

                        <!-- SITUACAO -->

                            <vss-select
                                title="contrato"
                                ref="situacaoInput"
                                class="is-100"
                                label="label"
                                :options="contratoList"
                                mlLabels
                                @input="updateContrato"
                                v-model="contratoSelected"
                                :height="40"
                                no-clearfix
                            />
                            <vss-select
                                title="situacao"
                                ref="situacaoInput"
                                class="is-100"
                                label="label"
                                :options="situacoes"
                                mlLabels
                                @input="updateSituacao"
                                v-model="situacao"
                                :height="40"
                                no-clearfix
                            />
                        </div>
                    </div>

                    <!-- TABELA -->
                    <div class="clients-table registry-wrapper" v-if="clients">
                        <container-loader v-if="isLoading && !$store.getters.isLoading" />
                        <empty-table-message v-if="isEmpty" />
                        <b-table
                            v-else
                            :data="clients"
                            class="data-table"
                            @sort="sortTable"
                            backend-sorting
                        >
                            <b-table-column
                                v-for="(f, i) in fields"
                                :key="i"
                                :field="f.key"
                                :label="f.key != 'excluir' ? $t(f.key) : ''"
                                :width="f.width"
                                :class="f.key != 'excluir' ? '' : 'excluir-field'"
                                :sortable="f.sortable"
                                :custom-sort="f.sortFn"
                                v-slot="props"
                            >
                                <div v-if="f.key == 'excluir' && permissao.delete">
                                    <b-button
                                        :type="
                                            props.row['situacao'] == 1
                                                ? 'is-danger'
                                                : 'is-success'
                                        "
                                        @click="promptChangeSituacao(props.row)"
                                        :icon-right="
                                            props.row.situacao == 1 ? 'delete ' : 'check'
                                        "
                                        position="is-left"
                                        v-tippy 
                                        :title="$t(props.row.situacao == 1 ? 'desativar' : 'reativar')"
                                    />
                                </div>

                                <div v-else-if="f.key == 'nome'">
                                    <router-link
                                        :to="{
                                            name: 'clientes-edit',
                                            params: { id: props.row.id },
                                        }"
                                    >
                                        {{ props.row[f.key] }}
                                    </router-link>
                                </div>
                                <div v-else-if="f.key == 'criado-em'">
                                    {{ props.row[f.key] | moment('L') }}
                                </div>
                                <div v-else-if="f.key == 'razaosocial'">
                                    {{ props.row[f.key] }}
                                </div>
                                <div v-else-if="f.key == 'cnpj-cpf'">
                                    <HideInfo
                                        v-if="!cleanHide"
                                        :value="props.row[f.key]"
                                        :hideInfo="hide.hideInfo"
                                        :infoIsHidden="hide.infoIsHidden"
                                        showPartInfoPosition="end"
                                        :showPartInfoLenght="4"
                                    />
                                </div>
                                <div v-else-if="f.key == 'situacao'">
                                    <b-tag
                                        class="table-tag table-tag-full-width"
                                        v-if="props.row[f.key] == 1"
                                        type="is-success"
                                        size="is-medium"
                                        >{{ $t('ativo') }}</b-tag
                                    >
                                    <b-tag
                                        class="table-tag table-tag-full-width"
                                        v-else
                                        type="is-danger"
                                        size="is-medium"
                                        >{{ $t('inativo') }}</b-tag
                                    >
                                </div>

                                <div v-else>
                                    {{ props.row[f.key] }}
                                </div>
                            </b-table-column>
                        </b-table>
                        <PaginationViewer
                            class="mb-0"
                            :resetPagination="pagination.resetPagination"
                            :totalItems="pagination.totalRows"
                            :perPageOptions="pagination.perPageOptions"
                            :optionStarted="pagination.optionStarted"
                            @change="updatePagination"
                        />
                    </div>
                </div>
            </div>
        </div>
        <router-view />
    </div>
</template>

<script>
import FilterBar from '@/components/shared/Filter';
import ClienteService from '@/services/promotor/ClienteService';
import { cpfcnpj } from '@/functions/masks';
import ContainerLoader from '@/components/content/loader/ContainerLoader';
import HideInfo from '@/components/shared/HideInfo';
import { mapState } from 'vuex';

export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name.includes('clientes') && to.name != 'clientes-list') {
            this.rotaAninhada = true;
        } else {
            this.rotaAninhada = false;
            this.carregarDados(this.pagination.currentPage);
        }
        next();
    },
    components: {
        FilterBar,
        ContainerLoader,
        HideInfo,
    },
    data() {
        return {
            rotaAninhada: false,
            cleanHide: true,
            clients: [],
            contratoList: [
                { id: 2, label: 'todos' },
                { id: 1, label: 'Com Contrato' },
                { id: 0, label: 'Sem Contrato' },
            ],
            contratoSelected: { id: 2, label: 'todos' },
            situacoes: [
                { id: 2, label: 'todos' },
                { id: 1, label: 'ativos' },
                { id: 0, label: 'inativos' },
            ],
            situacao: { id: 2, label: 'todos' },
            service: null,
            sURL: null,
            fields: [
                { key: 'codigo', width: 75, sortable: true, sortFn: null },
                { key: 'nome', width: null, sortable: true, sortFn: null },
                {
                    key: 'razaosocial',
                    width: null,
                    sortable: true,
                    sortFn: null,
                },
                { key: 'cnpj-cpf', width: 215, sortable: true, sortFn: null },
                {
                    key: 'criado-em',
                    width: 150,
                    sortable: true,
                    sortFn: this.sortCriadoEm,
                },
                { key: 'situacao', width: 70, sortable: false, sortFn: null },
                { key: 'excluir', width: 80, sortable: false, sortFn: null },
            ],
            larguraColunas: {
                nome: null,
                razaosocial: null,
                'cnpj-cpf': 180,
                'criado-em': 110,
                situacao: 100,
                excluir: 70,
            },
            carregando: true,
            isLoading: false,
            isEmpty: false,
            searchQuery: '',
            delete: null,
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            column: 'nome',
            order: 'asc',
            accessDenied: false,
            permissao: null,
        };
    },
    created() {
        if (this.$route.name.includes('clientes') && this.$route.name != 'clientes-list') {
            this.rotaAninhada = true;
        } else {
            this.rotaAninhada = false;
        }

        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];
        this.permissao = this.hasPermissionAccess('promotor', 'cadastros', 'clientes');
        if (!this.permissao.read) {
            this.accessDenied = true;
        } else {
            this.service = new ClienteService(this.$http, this.$router);
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
            this.carregarDados();
        }
    },
    computed: {
        ...mapState(['hide']),
    },
    methods: {
        promptChangeSituacao(row) {
            this.delete = row;
            if (row.contratosInRotas > 0 && row.situacao == 1) {
                this.$root.showMessage('alert', 'msg-excluir-cliente');
            } else {
                let message = this.$t(
                        row.situacao == 1
                            ? 'msg-confirmacao-desativacao-n'
                            : 'msg-confirmacao-reativacao-n', 
                        { n: row.nome }
                    );
                this.$root.confirm({
                    message: message,
                    onConfirm: this.updateSituacaoRegistro,
                    onCancel: this.removePrompt,
                });
            }
        },
        removePrompt() {
            this.delete = null;
        },
        updateSituacaoRegistro() {
            let tempFailure =
                this.delete.situacao == 1
                    ? 'msg-erro-ao-desativar-cliente'
                    : 'msg-erro-ao-reativar-cliente';

            let tempCliente = {
                idcliente: this.delete.id,
                situacao: this.delete.situacao == 1 ? 0 : 1,
            };

            this.isLoading = true;

            this.service
                .updateSituacao(tempCliente)
                .then((r) => {
                    if (r.status == 200) {
                        let tempSuccess =
                            r.content.situacao == 1
                                ? 'msg-sucesso-ao-reativar-cliente'
                                : 'msg-sucesso-ao-desativar-cliente';
                        this.$root.showMessage('success', tempSuccess);
                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage('error', 'Erro ao atualizar status.');
                    }
                })
                .catch((e) => {
                    console.error('Erro ao atualizar status.', e);
                    this.$root.showMessage('error', tempFailure);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
        infoIsHidden() {
            this.$store.dispatch('infoIsHidden', {
                infoIsHidden: !this.hide.infoIsHidden,
            });
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        carregarDados(currentPage = 1) {
            this.cleanHide = true;
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;
            this.isLoading = true;
            this.service
                .findAll(
                    this.column,
                    this.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.situacao.id,
                    this.searchQuery,
                    this.contratoSelected.id
                )
                .then(this.mapItems)
                .then((clients) => {
                    this.clients = clients;
                    this.isEmpty = this.clients.length <= 0;
                })
                .catch((e) => {
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar', e);
                })
                .finally(() => {
                    this.cleanHide = false;
                    this.pagination.resetPagination = false;
                    this.carregando = false;
                    this.isLoading = false;
                });
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados();
        },
        onSituacaoChanged(situacao) {
            this.situacao = situacao;
            this.carregarDados();
        },
        updateSituacao(t) {
            if (t) {
                this.situacao = t;
            } else {
                this.situacao = this.situacoes[0];
            }
            this.carregarDados();
        },
        updateContrato(velue) {
            if (velue) {
                this.contratoSelected = velue;
            } else {
                this.contratoSelected = this.contratoSelected[0];
            }
            this.carregarDados();
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;
            if (body.content) {
                return body.content.map((c) => {
                    return {
                        id: c.idcliente,
                        codigo: c.idclienteerp,
                        nome: c.nome,
                        razaosocial: c.rsocial,
                        endereco: c.endereco,
                        bairro: c.bairro,
                        cep: c.cep,
                        numero: c.numero,
                        'cnpj-cpf': cpfcnpj(c.cnpj),
                        'criado-em': c.datahorainc,
                        situacao: c.situacao,
                        contratosInRotas: c.contratosinrotas,
                        contrato: c.contrato,
                    };
                });
            }
            return [];
        },
        onSearch(value) {
            this.searchQuery = this.removeAcentos(value);
            this.searchQuery = this.searchQuery.replaceAll(/[./-]/g, '');
            this.carregarDados();
        },
        confirmExclusion(item) {
            this.deleteThis = item;
            if (item.contratosInRotas > 0) {
                this.$root.alert({
                    message: this.$t('msg-excluir-cliente'),
                    onConfirm: (_) => {
                        this.deleteThis = null;
                    },
                });
            } else {
                this.$root.confirm({
                    message: this.$t('msg-confirmacao-exclusao-n', { n: item.nome }),
                    onConfirm: this.excluir,
                    onCancel: (_) => {
                        this.deleteThis = null;
                    },
                });
            }
        },
        excluir() {
            let cliente = this.deleteThis;
            this.isLoading = true;
            this.service
                .delete(cliente.id)
                .then((_) => {
                    this.$root.showMessage('success', 'msg-success-excluir-cliente');
                    this.carregarDados(this.pagination.currentPage);
                })
                .catch((e) => {
                    console.error('Erro ao excluir cliente.', e);
                    this.$root.showMessage('error', 'msg-failure-excluir-cliente');
                    this.isLoading = false;
                })
                .finally((_) => {
                    this.deleteThis = null;
                });
        },
        parseDateString(d) {
            let a = d.split('T')[0].split('-');
            return new Date(a[0], a[1] - 1, a[2]).toLocaleDateString();
        },
        sortCriadoEm(a, b, isAsc) {
            let da = a['criado-em'].split('/').reverse().join('-');
            let db = b['criado-em'].split('/').reverse().join('-');
            if (isAsc) {
                return new Date(da).getTime() - new Date(db).getTime();
            } else {
                return new Date(db).getTime() - new Date(da).getTime();
            }
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0px 20px;
    height: 100%;

    .page {
        position: relative;
        padding-left: 0;
        .situacao-select div,
        .produtivo-select div {
            height: 40px;
        }
    }

    .clientes .search-and-filter {
        display: flex;
        justify-content: space-between;
        margin: 10px 0;
    }

    .clientes .search-and-filter {
        .search-bar {
            width: 80%;
        }
        .item-input {
            width: 19%;
        }
    }

    .clientes .search-and-filter .filter-bar {
        width: 31%;
    }
}
</style>
